import React from "react";
import LoginForm from "../../components/Auth/LoginForm";
import { UserType } from "../../api/authService";

export default function Login() {
  return (
    <LoginForm
      title="Business Owner Login"
      requiredUserType={UserType.BusinessOwner}
      homePath="/business"
    />
  );
}
